import React from 'react';
import './AdminSidePanel.css';


const BackDrop = (props) => {
    return <div className='backdrop'></div>
}

export default BackDrop;